module.exports = __webpack_public_path__ + "media/index6.d6cfec4c.webm";